import React, { useState } from 'react';
import Icon from './AppIcon';

const StarRating = ({ rating = 0, maxStars = 5, size = 16, showValue = true, reviewCount = null, interactive = false, onRate = null }) => {
  const [hovered, setHovered] = React.useState(0);

  const displayRating = interactive ? (hovered || rating) : rating;

  return (
    <div className="flex items-center space-x-1">
      <div className="flex items-center space-x-0.5">
        {Array.from({ length: maxStars }, (_, i) => {
          const starValue = i + 1;
          const filled = displayRating >= starValue;
          const halfFilled = !filled && displayRating >= starValue - 0.5;

          return (
            <button
              key={i}
              type="button"
              disabled={!interactive}
              onClick={() => interactive && onRate?.(starValue)}
              onMouseEnter={() => interactive && setHovered(starValue)}
              onMouseLeave={() => interactive && setHovered(0)}
              className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'} focus:outline-none`}
            >
              <Icon
                name="Star"
                size={size}
                className={
                  filled
                    ? 'text-yellow-400'
                    : halfFilled
                    ? 'text-yellow-300' :'text-muted-foreground/30'
                }
                style={filled || halfFilled ? { fill: filled ? '#FACC15' : '#FDE68A' } : {}}
              />
            </button>
          );
        })}
      </div>
      {showValue && (
        <span className="text-sm font-medium text-foreground ml-1">
          {rating > 0 ? rating?.toFixed(1) : '—'}
        </span>
      )}
      {reviewCount !== null && (
        <span className="text-xs text-muted-foreground">
          ({reviewCount} {reviewCount === 1 ? 'review' : 'reviews'})
        </span>
      )}
    </div>
  );
};

export default StarRating;
